import { render, staticRenderFns } from "./PointModal.vue?vue&type=template&id=73024654&scoped=true"
import script from "./PointModal.vue?vue&type=script&lang=js"
export * from "./PointModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73024654",
  null
  
)

export default component.exports